// extracted by mini-css-extract-plugin
export default {"button":"custombutton_button__CG0XN","buttonOutlined":"custombutton_buttonOutlined__GMq20","buttonText":"custombutton_buttonText__fekPA"};